import { msAPI, manageAPI } from "./index";

/**
 * Get document counts for multiple SKUs
 * @param {string[]} skus - Array of SKU IDs
 * @returns {Promise<{document_counts: Array}>}
 */
export async function getDocumentCounts(skus) {
  return (await msAPI.get(`merchant/products/document-count`, {
    params: { skus: skus.join(",") }
  })).data;
}

/**
 * Get documents for a specific SKU
 * @param {string} sku_id - The SKU ID
 * @returns {Promise<{data: Array}>}
 */
export async function getProductDocuments(sku_id) {
  return (await manageAPI.get(`product/${sku_id}/documents`)).data;
}

/**
 * Upload a product document
 * @param {string} sku_id - The SKU ID
 * @param {Object} documentData - Document metadata
 * @param {string} documentData.display_name - Display name for the document
 * @param {boolean} documentData.show_on_website - Whether to show on website
 * @param {string} documentData.url - URL of the uploaded file
 * @param {string} documentData.bucket - S3 bucket name
 * @param {string} documentData.key - S3 key
 * @param {string} documentData.filename - Original filename
 * @param {string[]} store_ids - Array of store IDs to apply the document to
 * @returns {Promise<{document: Object}>}
 */
export async function createProductDocument(sku_id, documentData, store_ids = []) {
  return (await manageAPI.post(`product/${sku_id}/documents`, {
    document: documentData,
    store_ids: store_ids
  })).data;
}

/**
 * Update a product document
 * @param {string} document_id - The document ID
 * @param {Object} updates - Document updates
 * @returns {Promise<{document: Object}>}
 */
export async function updateProductDocument(document_id, updates) {
  return (await manageAPI.patch(`product/documents/${document_id}`, updates)).data;
}

/**
 * Delete a product document
 * @param {string} document_id - The document ID
 * @returns {Promise<{success: boolean}>}
 */
export async function deleteProductDocument(document_id) {
  return (await manageAPI.delete(`product/documents/${document_id}`)).data;
}
